/**
 *
 * @type {{bindAll: Function, bindToAddToCartButton: Function, countrySelector: Function, bindToAddToCartForm: Function, bindToAddToCartStorePickUpForm: Function, displayAddToCartPopup: Function, trackAddToCart: Function, showCCnotFoundMessages: Function, bindBuyOnline: Function, bindBuyInStore: Function, bindBuyOnlineChangeCountry: Function, checkBuyOnline: Function, checkBuyInStore: Function, displayBuyOnline: Function, buyonlineRedirect: Function, buyinstoreRedirect: Function, displayBuyInStore: Function, getBuyInStoreShops: Function, getBuyInStoreShopsWithLocateMe: Function, positionSuccessStoresNearMe: Function}}
 */

ACC.product = {

    /**
     *
     */
    bindAll: function () {
        ACC.product.bindToAddToCartForm();
        ACC.product.bindToAddToCartStorePickUpForm();
        ACC.product.bindToAddToCartButton();
        ACC.product.bindBuyOnline();
    },

    /**
     *
     */
    bindToAddToCartButton: function () {
        $('#addToCartButton').prop("disabled",false);
    },

    /**
     *
     */
    countrySelector: function () {
        $('#CountrySeletorBC').on('click',function () {
            $('#country-selector-bc').toggle();
        });
        $('#country-selector-bc').on('mouseleave',function () {
            $('#country-selector-bc').hide();
        });
    },

    /**
     *
     */
    bindToAddToCartForm: function () {
      $(document).on('submit','.add_to_cart_form', function (event) {
          event.preventDefault();
          $('.add-panier').attr('disabled', true);
          $.ajax({
            url: ACC.config.contextPath + $(this).prop('action'),
            data: $(this).serialize(),
            method: $(this).prop('method'),
            beforeSend: function(arr, $form, options) {
              $('.add-panier').attr('disabled', true);
            },
          }).done(function (data) {
            ACC.product.displayAddToCartPopup(data)
          }).fail(function(){
            $('.add-panier').attr('disabled', true);
          });
        }
      );
      $("button.add-to-cart").attr("type", "submit");
    },

    /**
     *
     */
    bindToAddToCartStorePickUpForm: function () {
      /**
       *
       * @type {*|jQuery|HTMLElement}
       */
      $('.add_to_cart_storepickup_form').on('submit',
        function (event) {
          event.preventDefault();
          $.ajax({
            url: ACC.config.contextPath + $(this).prop('action'),
            data: $(this).serialize(),
            method: $(this).prop('method')
          }).done(function (data) {
            ACC.product.displayAddToCartPopup(data)
          });
        }
      );
    },

    /**
     *
     * @param cartResult
     * @param statusText
     * @param xhr
     * @param formElement
     */
    displayAddToCartPopup: function (cartResult, statusText, xhr, formElement) {
        $('.add-panier').prop( "disabled", false );
        // update mini cart
        if (typeof ACC.cartpopup.refreshMiniCart == 'function') {
            ACC.cartpopup.refreshMiniCart();
        }
        // display add to cart confirmation
        /**
         *
         * @type {string}
         */
        var modalId = "ModalProductBuy";
        if (!cartResult.cartError.msg.length == 0) {
            modalId = "ModalCartError";
            $('body')
                .append(
                $('<div />')
                    .html(cartResult.cartError.msgModalHtml)
                    .text());
        } else {
            $('body')
                .append($('<div />').html(cartResult.cartModalHtml).text());
        }
        // Add modal
        /**
         *
         * @type {string}
         */
        var selectModal = '#' + modalId;
        $(selectModal).show();
        $(selectModal).modal();

        // Ajout fonction sur l'event hide pour supprimer la modal
        $(selectModal).on('hidden.bs.modal', function () {
            $(selectModal).remove();
        });

        // send analytics event
        /**
         *
         * @type {*|jQuery}
         */
        var productCode = $('[name=productCodePost]', formElement).val();

        /**
         *
         * @type {*|jQuery}
         */
        var quantityField = $('[name=qty]', formElement).val();

        /**
         *
         * @type {number}
         */
        var quantity = 1;
        if (quantityField != undefined) {
            quantity = quantityField;
        }
        ACC.product.trackAddToCart(productCode, quantity, cartResult);
    },

    /**
     *
     * @param productCode
     * @param quantity
     * @param cartData
     */
    trackAddToCart: function (productCode, quantity, cartData) {
        window.mediator.publish('trackAddToCart', {
            productCode: productCode,
            quantity: quantity,
            cartData: cartData
        });
    },

    //BRA-1232
    /**
     *
     */
    showCCnotFoundMessages: function () {
        //afficher les messages d'erreur qu'aucun distributeur n'est trouv�
        $('.distributor-not-found-msg').show();

        //bind le click sur le message : buyonline.cc.nofound.find.store pour rediriger vers la popin buy in store
        $(document).on('click', '.return-buy-in-store', function (e) {
            e.preventDefault();
            $('.product-detail .buyinstore').trigger('click');
        });
        // cacher la zone des distributeurs
        $('#myCarouselBC').hide();
    },

    /**
     *
     */
    bindBuyOnline: function () {
        $(".return-buyonline").on("click", function (e) {
            e.preventDefault();
            $('.product-detail .buyonline').trigger('click');
        });

        $(".buyonline").on("click", function (e) {
            ACC.product.checkBuyOnline(this);
            e.preventDefault();
        });
    },


    /**
     *
     */
    bindBuyOnlineChangeCountry: function () {
        $(document).on('click', '.buyonlineChangeCountry', function (e) {
            //$(".buyonlineChangeCountry").on("click", function(e) {
            e.preventDefault();
            ACC.product.checkBuyOnline(this);
        });
    },

    /**
     *
     * @param element
     */
    checkBuyOnline: function (element) {
        /**
         *
         * @type {null}
         */
        var seoUrl = null;
        if ($(element).parent().find('.buyonline[seo-data-url]').length != 0) {
            seoUrl = $(element).attr('seo-data-url');
        }
        else {
            seoUrl = $(element).attr('href');
        }
        $.ajax({
            url: seoUrl + "/ajax", async: false
        }).done(function (data) {
            console.log(data.message);
            // redirect dans le cas d'une erreur ou specific link
            if (data.reponseCode == 'redirect') {
                ACC.product.buyonlineRedirect(data.redirectUrl);
            } else if (data.reponseCode == 'open-popin' || data.reponseCode == 'open-ccs-not-found-popin') { // afficher popin (mm si aucun distributeur n'est trouv�) si aucun prb n'est servenu au WS et si le spesefic link n'est pas activ�
                ACC.product.displayBuyOnline(element, data.reponseCode);
            }
        });
    },

    /**
     *
     * @param element
     * @param redirectType
     */
    displayBuyOnline: function (element, redirectType) {
        $.ajax({
            url: $(element).attr('seo-data-url') + "/popin/ajax"
        }).done(function (html) {
            $("#ModalCommerce").addClass("modal-business");
            $("#ModalCommerce .modal-body").html(html);
            $("#ModalCommerce").show();
            $("#ModalCommerce").modal();
            ACC.product.countrySelector();
            ACC.product.bindBuyOnlineChangeCountry();
            // Ajout fonction sur l'event hide pour supprimer le contenu de la
            // modal
            $("#ModalCommerce").on('hidden.bs.modal', function () {
                $("#ModalCommerce .modal-body").html("");
                $("#ModalCommerce").removeClass("modal-business");
            });

			var sliderOptions = {
				items : 1,
				slideBy : 1,
				stageElement : "ul",
				itemElement : "li",
				loop : true,
				nav : true,
				dots : false,
				mouseDrag : false,
				touchDrag : true,
				smartSpeed: 500
			}

            if ($(window).width() > 720) {
                if ($('.commerce-connector .item').length > 1) {
                	var $commerceConnectorSlider = $('.commerce-connector');

                	$commerceConnectorSlider.on("initialized.owl.carousel", function(){
                		$commerceConnectorSlider.find(".owl-stage-outer").addClass("commerce-connector-wrapper");
                	});

                	$commerceConnectorSlider.owlCarousel(sliderOptions);
                }
            } else {
                $('.commerce-connector .seller').each(function () {
                    $('.commerce-connector').append($(this));
                });
                $('.commerce-connector .item').remove();

            	var $commerceConnectorSlider = $('.commerce-connector');

            	$commerceConnectorSlider.on("initialized.owl.carousel", function(){
            		$commerceConnectorSlider.find(".owl-stage-outer").addClass("commerce-connector-wrapper");
            	});

            	$commerceConnectorSlider.owlCarousel(sliderOptions);
            }

            $('#ModalCommerce').find('.modal-body').css({
                'max-height': '100%'
            });

            //#BRA-1232
            if (redirectType == 'open-ccs-not-found-popin') {
                ACC.product.showCCnotFoundMessages();
            }

            // bind function for product range on select change
            $('#SelectbusinessRange').on('change',function (event) {
                if ($('#SelectbusinessRange').val() != '') {
                    $.ajax({
                        type: "GET",
                        url: $('#SelectbusinessRange').val()
                    }).done(function (data) {
                        var IS_JSON = true;
                        try {
                            var json = $.parseJSON(data);
                            //BRA-1232
                            // il faut rediriger vers where to buy seulement si on a un spesific link = ( cad : redirect avec aucun message d'erreur )
                            if (json.reponseCode == 'redirect' && json.errorMessage == '') {
                                ACC.product.buyonlineRedirect(json.redirectUrl);
                            } else {
                                ACC.product.showCCnotFoundMessages();
                            }
                        } catch (err) {
                            IS_JSON = false;
                        }
                        if (!IS_JSON) {
                            //BRA-1232
                            // supprimer les message d'erreurs distributeur Not found, qui peuvent etre affich� pr un autre produit qui n'a aucun distributeur
                            $('.distributor-not-found-msg').hide();

                            // data is ur summary
                            $('#StoreConnectorAjax').html(data);
                            //Analytic.bindAllEvents($("#StoreConnectorAjax"));
                            // activate carrousel

                			var commerceConnectorSliderOptions = {
                					items : 1,
                					slideBy : 1,
                					stageElement : "ul",
                					itemElement : "li",
                					loop : false,
                					nav : true,
                					dots : false,
                					mouseDrag : false,
                					touchDrag : true,
                					smartSpeed: 500
                				}

                            var $commerceConnectorSlider = $('.commerce-connector');

                        	$commerceConnectorSlider.on("initialized.owl.carousel", function(){
                        		$commerceConnectorSlider.find(".owl-stage-outer").addClass("commerce-connector-wrapper");
                        	});

                        	$commerceConnectorSlider.owlCarousel(commerceConnectorSliderOptions);
                        }
                    }).fail(function (data) {
                        $('#StoreConnectorAjax').html("Error");
                    });
                }
            });
            //analytics binding
            //Analytic.bindAllEvents($("#ModalCommerce"));

        }).fail(function (html) {
            $("#ModalCommerce .modal-body").html(html.responseText);
            $("#ModalCommerce").show();
            $("#ModalCommerce").modal();
            // Ajout fonction sur l'event hide pour supprimer le contenu de la
            // modal
            $("#ModalCommerce").on('hidden.bs.modal', function () {
                $("#ModalCommerce .modal-body").html("");
            });
        });
    },

    /**
     *
     * @param url
     */
    buyonlineRedirect: function (url) {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var a = $("#buyonline-redirect-link");
        a.attr("href", url);
        // check external url
        /**
         *
         * @type {RegExp}
         */
        var hostRegEx = new RegExp(location.host);

        /**
         *
         * @type {RegExp}
         */
        var absoluteUrlRegEx = new RegExp('^(?:[a-z]+:)?//', 'i');
        if (!absoluteUrlRegEx.test(url)) {
            // a link that contains the current host
            // so open the link into the same window
            a[0].click();
        } else {
            // a link that does not contain the current host
            // //so open the link in another window
            a.attr("target", "_blank");
            a[0].click();
        }
    },
    positionRetrySuccessNearMe: function (position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        if (lat != null && lat != undefined && lng != null && lng != undefined) {

            var url = $("#buyInStoreForm").attr('action');
            if ($("#SelectbusinessRange").val() != null) {
                url = $("#SelectbusinessRange").val();
            }
            jQuery.ajax({
                type: "GET",
                url: url,
                data: "&lng=" + lng + "&lat=" + lat + "&" + $("#buyInStoreForm").serialize(),
            }).done( function (data) {
                initScrollingStoreList();
                $('#MapStoreStok').html(data);
                ACC.product.bindBuyOnline();
            });
        }
    }
};

function getGglAPIKey(){
	var key = null;
    jQuery.ajax({
        type: "GET",
        url:"/buyonline/gglApiKey/ajax",
        async:false
    }).done( function (data) {

        key=data;
    }).fail( function(xhr, status, error) {
        console.log("Cannot get key api !");
    });
    return key;
}
